import api from 'api-promise';
import alerts from 'alerts-promise';
import BMClerk from 'bm-clerk';
import Template from 'template';
import loadComponent from 'load-component';
import responseHandler from 'response-handler';
import setSplideCustomButtons from 'set-splide-custom-buttons';
import t from 'translate';

'use strict';

var favoritesLoading = {};

window.med24 =
{
	addProductToCart: (productID, quantity) =>
	{	//2017-08-10
		api.cart.add(productID, quantity).then(async response =>
		{
			const doneCallback = () =>
			{
				// Google Analytics
				if (response.TMAddToCartCode) window?.dataLayer?.push(response.TMAddToCartCode);
				// Matomo
				if (response.TMAddToCartCodeMatomo) window?._paq?.push(...response.TMAddToCartCodeMatomo);

				med24.updateCartItemCount();
				
				if(response.status === 0) med24.showPowerstepPopup(productID);
			}

			if(response.status !== 0) 
			{
				if(response.status === -2) 
				{
					const alertMessageTpl = new Template('onlyMembersSampleAlertMessage');
					const alertMessage = alertMessageTpl.compile();
					
					await alerts.alert(alertMessage, 'info', 'html');
				}
				else
				{
					await alerts.alert(response.message);
				}
			}

			doneCallback();
		});
	},
	addDiscountCodeFromURL:async (code) => {
	 const response =	await api.discountCode.add(code)
	 if(response.status !== 0) return responseHandler(response);

	 // 2026-10-22 SC #51785 — the code is stored now, so it leaves servedURL: a reload to it (response-handler.js) must not
	 // apply it again, e.g. right after "Fjern rabat" on /kurv
	 const servedURL = new URL(window.servedURL || window.location.href);
	 servedURL.searchParams.delete('discountCode');
	 if(window.servedURL) window.servedURL = servedURL.href;

	 med24.updateCartItemCount();

	 // "Discount code X has been added" and what it gives (WebService2\DiscountCode::add); the same popup as a bad
	 // code's, as text: a gift text is admin-entered, never HTML
	 if(typeof response.popupTitle === 'string') await alerts.alert(response.popupText || '', response.popupTitle);

	 // a count asked while add's request is still writing the session can read the code before; by now it is stored
	 med24.updateCartItemCount();

	 // /kurv was rendered before the code was stored: show it with the code
	 if(document.querySelector('section.cart.tw-container')) window.location.replace(servedURL.href);
	},
	updateCartItemCount: (selector, isRetry) =>
	{	//2017-08-08
		selector = selector || 'header div.links span.cartQuantity, header .stickyHeader span.cartQuantity';

		// 2026-10-22 SC #51785 — only the newest count is shown: the page-load count can answer after the one asked
		// right after a ?discountCode link changed the cart's code. Since an older answer is dropped, a newest count that
		// fails is asked once more, so the badge is not left with what it showed before.
		const countRequest = med24.cartItemCountRequest = (med24.cartItemCountRequest || 0) + 1;

		return api.cart.getItemCount(false).then(response =>
		{
			if(countRequest !== med24.cartItemCountRequest) return;
			if(typeof response.itemCount !== 'number') return isRetry ? undefined : med24.updateCartItemCount(selector, true);

			for(const cartQuantity of document.querySelectorAll(selector))
			{
				const image = cartQuantity.parentElement.querySelector('img');

				// 2026-10-22 SC #51785 — every counter (header and sticky header): a return here hid only the first, so a
				// count that drops to 0 without a reload (a ?discountCode link replacing a gift code) kept showing
				if(response.itemCount === 0)
				{
					image.setAttribute('src', image.dataset.icon);
					cartQuantity.classList.add('!tw-hidden');
					continue;
				}
				
				image.setAttribute('src', image.dataset.blackIcon);
				cartQuantity.classList.remove('!tw-hidden');
				cartQuantity.textContent = response.itemCount;
			}
		}, error =>
		{
			// an older count's failure, or the retry's, reaches the caller as before
			if(countRequest !== med24.cartItemCountRequest || isRetry) throw error;

			return med24.updateCartItemCount(selector, true);
		});
	},
	updateFavoritesCount: (count) =>
	{
		const favoritesIcon = document.querySelector('header div.links .image.favorites');	
		const favoritesCount = favoritesIcon?.querySelector('.favoritesCount');
		if(!favoritesCount || !favoritesIcon) return;
		
		if (count === 0) return favoritesCount.classList.add('!tw-hidden');

		if(typeof count === 'undefined')
		{
			api.customer.getFavoritesCount().then(response =>
			{
				favoritesCount.innerHTML = response.favoritesCount;
			});
		}
		else
		{
			favoritesCount.innerHTML = count;
		}

		favoritesCount.classList.remove('!tw-hidden');
	},
	showPowerstepPopup: (productID) =>
	{
		if(window.innerWidth < 375)
		{
			med24.showCartPopup();
			return;
		}
		
		if(typeof productID === 'string') productID = parseInt(productID.replace(/[^0-9]+/ig, '')); // Clerk expects an int
		
		const powerstepHTML = (new Template('powerstep')).compile();
		const splideContainer = powerstepHTML.querySelector('.splide');
		const splideList = splideContainer.querySelector('.splide__list');

		const options =
		{
			productIDs: [productID],
			limit: 6,
			filter: 'soldOut = false and isSample = false and categories contains not 2657 and categories contains not 131'
		};
		
		BMClerk.addRelatedProducts(splideList, options).then(() =>
		{
			const existingPowerstepOverlay = document.querySelector('.powerstepOverlay');
			
			if(existingPowerstepOverlay) existingPowerstepOverlay.remove();
			
			const overlay = alerts.createOverlay(true, ['powerstepOverlay']);
			
			powerstepHTML.querySelectorAll('.continueShopping, .closeIcon').forEach(elm => elm.addEventListener('click', event => overlay.close()));
			powerstepHTML.addEventListener('click', event => event.stopPropagation());
			overlay.overlay.addEventListener('click', event => overlay.close());
			
			overlay.overlay.append(powerstepHTML);

			// to find preDefined splide settings search for 'Splide.defaults' in med24-global.js
			let splide = new Splide(splideContainer, {padding: { left: '2px', right: '2rem'}, breakpoints: { 640: { padding: { left: '2px', right: '4rem'} }, 1536: { perPage: 4 }}});
			splide.mount();

			setSplideCustomButtons(splideContainer, splide, powerstepHTML);
		});
	},
	showCartPopup: async () =>
	{	//2017-08-09
		const cartDialogTpl = new Template('cartPopup');
		const cartDialogProductTpl = new Template('cartPopupProductRow');
		
		const productsPromise = api.cart.getProducts();
		const totalPromise = api.cart.getProductTotal();
		
		const [productsResponse, totalsResponse] = await Promise.all([productsPromise, totalPromise]);

		const cartPopup = cartDialogTpl.compile({productTotal:totalsResponse.total});
		
		const productContainer = cartPopup.querySelector('div.products');
		
		for(const productKey in productsResponse.products)
		{
			const product = productsResponse.products[productKey];

			const cartDialogProduct = cartDialogProductTpl.compile(product);
			
			cartDialogProduct.querySelector('button.remove').addEventListener('click', async () =>
			{
				const response = await api.cart.remove(product.productID);
				
				// Matomo
				if (response.TMAddToCartCodeMatomo) window?._paq?.push(...response.TMAddToCartCodeMatomo);

				await med24.updateCartItemCount();
				
				med24.showCartPopup();
			});
			
			productContainer.appendChild(cartDialogProduct);
		};

		
		cartPopup.querySelector('button.continueShopping').addEventListener('click', event => cartPopup.remove());
		
		const headerCartPopup = document.querySelector('header>div.cartPopup');
		if(headerCartPopup) headerCartPopup.remove(); //remove any existing popups
		
		const header = document.querySelector('header');
		if(header) header.appendChild(cartPopup);
		
		const clickOutsideHandler = event =>
		{
			let targetElement = event.target; // clicked element
			
			do
			{
				if(targetElement == cartPopup) return; // This is a click inside. Do nothing, just return.
				
				// Go up the DOM
				targetElement = targetElement.parentNode;
			} while(targetElement);
			
			// This is a click outside.
			cartPopup.remove();
			
			document.removeEventListener('mouseup', clickOutsideHandler);
		};
		
		//remove if clicked outside of cart popup
		document.addEventListener('mouseup', clickOutsideHandler);
	},
	initPriceBadges: (productThumbQuery) =>
	{
		const productThumbs = document.querySelectorAll(productThumbQuery);

		for(const productThumb of productThumbs)
		{
			if(productThumb.classList.contains('priceBadgesInitialized')) continue;

			const pricesElement = productThumb.querySelector('div.prices');
			const normalPriceContainer = productThumb.querySelector('.overlayContainer.normalPrice');
			const discountContainer = productThumb.querySelector('.overlayContainer.discount');
			const leftContainer = productThumb.querySelector('.overlayContainer.left');

			const isMemberPrice = (pricesElement?.getAttribute('data-is-member-price') === 'true');
			const isOnOffer = (pricesElement?.getAttribute('data-is-on-offer') === 'true');
			const normalPrice = pricesElement?.getAttribute('data-normal-price');
			const discountPercentage = pricesElement?.getAttribute('data-discount-percentage');

			if(isMemberPrice)
			{
				normalPriceContainer.textContent = t('RRP %s',normalPrice);
				normalPriceContainer.classList.remove('hidden');
			}
			else if(isOnOffer)
			{
				discountContainer.textContent = t('%s%',discountPercentage);
				discountContainer.classList.remove('hidden');
			}

			if(leftContainer && (isMemberPrice || isOnOffer))
			{
				leftContainer.classList.add('memberOfferPriceAdjustTop');
			}

			productThumb.classList.add('priceBadgesInitialized');
		}
	},
	initFavorite: (favoritesQuery, productID) =>
	{
		const favorites = document.querySelectorAll(favoritesQuery);
		// console.log(favorites);
		// favorites = Array.from(favorites);
		// = Array.from(favorites).filter(function(element) {
		// 	const style = window.getComputedStyle(element);
		// 	return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
		// });

		if(!((window.customer || {}).loaded))
		{
			window.addEventListener('fetchedCustomerData', (event) =>
			{
				const customerID = event.detail.customerID;
				
				med24.initFavorite(favoritesQuery, productID);
			});
			
			return;
		}
		
		for(const favorite of favorites)
		{
			favorite.addEventListener('click', async event =>
			{
				event.preventDefault();
				event.stopPropagation();
				const target = event.currentTarget;
				const toggleFavorite = () =>
				{
					if(typeof favoritesLoading[productID] !== 'undefined') return;
					
					favoritesLoading[productID] = true;

					api.customer.toggleFavoriteProduct(productID).then(response =>
					{
						// 23-10-2024 Fedor, we did this changes because document.querySelectorAll(favoritesQuery) select also and mobile version of favorites.

						// for(const elem of document.querySelectorAll(favoritesQuery))
						// {
							// Matomo
							if (response.favorited && response.TMAddToCartCodeMatomo) window?._paq?.push(...response.TMAddToCartCodeMatomo);

							// elem.classList[response.favorited?'add':'remove']('favorited');
							target.classList[response.favorited?'add':'remove']('favorited');
						// }
						
						med24.updateFavoritesCount(response.favoritedProductCount);
						
						delete favoritesLoading[productID];
					});
				};
				
				if(customer.loggedIn)
				{
					toggleFavorite();
				}
				else
				{
					await loadComponent('login-or-signup-popup');
					
					const overlay = alerts.createOverlay(false);
					
					const loginOrSignup = document.createElement('login-or-signup-popup');
					const emailInput = loginOrSignup.shadowRoot.querySelector('.login input[name="email"]');
					
					loginOrSignup.addEventListener('close', event => overlay.close());
					
					loginOrSignup.addEventListener('login-completed', event =>
					{
						api.customer.getData().then(response =>
						{
							window.customer = response.customerData;
							window.customer.loaded = true;
							
							const alreadyFavorited = (customer.favoritedProductIDs.indexOf(productID)!==-1);
							
							if(!alreadyFavorited) toggleFavorite();
							
							location.reload();
						});
					});
					
					overlay.overlay.append(loginOrSignup);
					
					overlay.show();
					
					setTimeout(() => { emailInput.focus(); }, 100);
				}
			});
		}
		
		for(const favorite of favorites)
		{
			favorite.classList[(customer.favoritedProductIDs.indexOf(productID)!==-1)?'add':'remove']('favorited');
			
			favorite.classList.remove('hidden');
		}
	},
	initProductThumb: (productID) =>
	{
		med24.initFavorite('.productThumb[data-product-id="'+productID+'"] .favorite', productID);
		med24.initPriceBadges('.productThumb[data-product-id="'+productID+'"]');
		med24.initVariantStrip('.productThumb[data-product-id="'+productID+'"] [data-variant-strip]');
	},
	/**
	 * #48359 — variant strip on a grid thumb. The server renders up to five chips plus a
	 * "+N"; the strip is one line, so how many actually fit depends on the column width.
	 * This hides the chips that do not fit and rewrites the "+N" from the group total,
	 * which is the behaviour the design shows (a single wide label chip leaves room for
	 * nothing but "+10").
	 */
	initVariantStrip: (stripQuery) =>
	{
		for(const strip of document.querySelectorAll(stripQuery))
		{
			med24.orderVariantStripByRelevance(strip);
			med24.fitVariantStrip(strip);
			med24.observeVariantStripWidth(strip);
		}
	},
	/**
	 * #48359 — fits one strip to the width it has now. Starts from every chip shown, so a strip
	 * that got wider shows again the chips a narrower fit hid; the order is left as it is.
	 */
	fitVariantStrip: (strip) =>
	{
		med24.variantStripFittedWidths.set(strip, strip.clientWidth);

		const overflowElement = strip.querySelector('[data-variant-overflow]');
		const chips = Array.from(strip.querySelectorAll('.variantThumbChip'));

		if(overflowElement === null || chips.length === 0) return;

		const total = parseInt(strip.getAttribute('data-variant-total'), 10) || chips.length;

		// Measure with everything shown, then drop chips from the end until the row fits
		// alongside the "+N" it will need. The "+N" is rewritten with every chip dropped
		// (2026-10-14): measured with the server's shorter "+9", a strip that ends at "+10"
		// lost its last digit (8303 at 390px).
		chips.forEach(chip => { chip.classList.remove('hidden'); chip.style.maxWidth = ''; });
		overflowElement.classList.remove('hidden');

		let shown = chips.length;
		overflowElement.textContent = '+' + (total - shown);

		while(shown > 1 && strip.scrollWidth > strip.clientWidth)
		{
			shown--;
			chips[shown].classList.add('hidden');
			overflowElement.textContent = '+' + (total - shown);
		}

		// 2026-10-14 #48359: one label wider than the strip left no room for the "+N", which was cut
		// off with the label (12755 at 390px: "Strawberry blonde" in a 131px strip). The last chip
		// standing gives up exactly the overflow, and its label ends in an ellipsis
		// (productGrid.less), so the "+N" always shows.
		const overshoot = strip.scrollWidth - strip.clientWidth;
		if(overshoot > 0) chips[0].style.maxWidth = Math.max(0, chips[0].offsetWidth - overshoot) + 'px';

		overflowElement.classList.toggle('hidden', total - shown <= 0);
	},
	/**
	 * #48359 (2026-10-14) — a strip kept the cut of the width it was fitted at: a window resized or
	 * a phone turned without a reload left 390px showing the 1440px fit, "Terra | swatch | swatch | +"
	 * with the "6" cut off. One ResizeObserver for every strip on the page re-fits a strip whose
	 * width is not the one it was last fitted to (variantStripFittedWidths), so a height-only change
	 * does nothing. The fit never changes the strip's own box (absolute, left/right, fixed height —
	 * productGrid.less), so a re-fit reports nothing back and cannot loop; it still runs a frame
	 * later, as the product page's variant selector does, so no change made inside the observer's
	 * pass can raise the browser's loop error. A thumb added later (filter, "Vis flere", a carousel)
	 * is observed by its own initProductThumb().
	 */
	variantStripFittedWidths: new WeakMap(),
	variantStripResizeObserver: null,
	observeVariantStripWidth: (strip) =>
	{
		if(typeof ResizeObserver !== 'function') return;

		if(med24.variantStripResizeObserver === null)
		{
			med24.variantStripResizeObserver = new ResizeObserver(entries => requestAnimationFrame(() => med24.refitVariantStrips(entries)));
		}

		med24.variantStripResizeObserver.observe(strip);
	},
	refitVariantStrips: (entries) =>
	{
		const observer = med24.variantStripResizeObserver;

		// A strip that left the page (a new filter empties the grid) is let go; should it come back,
		// the next scan below takes it up again.
		entries.filter(({target}) => !target.isConnected).forEach(({target}) =>
		{
			observer.unobserve(target);
			med24.variantStripFittedWidths.delete(target);
		});

		// Every strip on the page, not only those reported: Splide's loop carousels clone their slides
		// (cloneNode, so a clone's inline script never runs), and a clone is first seen here. All widths
		// are read before the first fit, so the reads cost one layout; a fit changes no strip's width.
		const strips = Array.from(document.querySelectorAll('[data-variant-strip]'), strip => [strip, strip.clientWidth]);

		for(const [strip, width] of strips)
		{
			if(!med24.variantStripFittedWidths.has(strip)) observer.observe(strip);
			if(width !== med24.variantStripFittedWidths.get(strip)) med24.fitVariantStrip(strip);
		}
	},
	/**
	 * #48359 (2026-09-04) — the strip's chips follow the grid's ranking of the group's members:
	 * on a category or brand page the grid's sort (popularity, price, ...) applied to every
	 * member before the collapse, on a search page the engine's relevance. The thumb is a
	 * per-product cached fragment, so the server cannot order them per page; instead it ships
	 * every member as [productID, chip] in data-variant-members (fallback order: in stock
	 * first, then the API's sort order) and Filter puts the ranking on the grid container as
	 * data-variant-member-order. Ranked members come first, in rank order; the rest keep the
	 * fallback order behind them. No ranking on the page (wishlist, carousels) = server order.
	 */
	orderVariantStripByRelevance: (strip) =>
	{
		const orderHost = strip.closest('[data-variant-member-order]');
		if(orderHost === null) return;

		let memberOrder = [];
		let members = [];

		try
		{
			memberOrder = JSON.parse(orderHost.getAttribute('data-variant-member-order')) || [];
			members = JSON.parse(strip.getAttribute('data-variant-members')) || [];
		}
		catch(error)
		{
			return;
		}

		if(memberOrder.length === 0 || members.length === 0) return;

		// First occurrence wins: the list is several rankings appended, best source first.
		const rankByID = new Map();
		memberOrder.forEach((productID, index) => { if(!rankByID.has(Number(productID))) rankByID.set(Number(productID), index); });

		const ranked = members.map(([productID, chip, kind], index) => ({chip, kind, index, rank: rankByID.has(Number(productID)) ? rankByID.get(Number(productID)) : Infinity}));

		if(!ranked.some(member => member.rank !== Infinity)) return; // nothing to lift, server order stands

		ranked.sort((a, b) => (a.rank === b.rank) ? a.index - b.index : a.rank - b.rank);

		const chips = Array.from(strip.querySelectorAll('.variantThumbChip'));
		const isColourStrip = strip.classList.contains('variantThumbStrip--swatch');
		const overflowElement = strip.querySelector('[data-variant-overflow]');

		chips.forEach(chip => chip.remove());

		// Same number of chips the server rendered (its limit), rebuilt from the members in the new order,
		// each as productThumb.tpl draws it (2026-10-14): the server picked its kind with the product page's
		// ladder and ships it as the member's third entry — 'swatch' or 'image'; none = a label.
		ranked.slice(0, chips.length).forEach(member => strip.insertBefore(med24.variantThumbChip(member.chip, member.kind, isColourStrip), overflowElement));
	},
	/**
	 * #48359 (2026-10-14) — one strip chip, the same markup productThumb.tpl prints for that kind.
	 */
	variantThumbChip: (value, kind, isColourStrip) =>
	{
		if(kind === 'image')
		{
			// loading before src (2026-10-14): an img starts fetching the moment it gets a src, even before
			// it is in the page, so set the other way round every chip photo loaded up front — those hidden
			// behind the "+N" and far below the fold included (55 of 55 on haarfarve at 390px).
			const image = document.createElement('img');
			image.loading = 'lazy';
			image.className = 'variantThumbChip variantThumbChip--image';
			image.alt = '';
			image.width = 27;
			image.height = 21;
			image.src = value;

			return image;
		}

		const chip = document.createElement('span');
		chip.className = 'variantThumbChip';

		// Only a #RRGGBB value reaches the style, as in the template (2026-10-07).
		if(kind === 'swatch' && /^#[0-9A-Fa-f]{6}$/.test(value))
		{
			chip.style.backgroundColor = value;

			return chip;
		}

		chip.textContent = value;
		if(isColourStrip) chip.classList.add('variantThumbChip--text');

		return chip;
	},
	imageHovered(event)
	{
        var hoveredElement = event.target;
        var nearestImg = hoveredElement.querySelector('.scaleImage');
        nearestImg.setAttribute('src', nearestImg.dataset.hoverSrc);
    },
    imageUnHovered(event)
	{
        var hoveredElement = event.target;
        var nearestImg = hoveredElement.querySelector('.scaleImage');
        nearestImg.setAttribute('src', nearestImg.dataset.src);
    },
	autoFocusSearchFiltersOnDesktop(el)
	{
		if (window.currentTwDevice === 'xs') return;
		el.querySelector('input.filterSearch')?.focus();
	}
};

console.debug('%cmed24loaded', 'color:blue;');

window.dispatchEvent(new Event('med24loaded'));
